interface PrefillPillProps {
  source?: string
  className?: string
}

const LABELS: Record<string, string> = {
  oura: 'From Oura',
  apple_health: 'From Apple Health',
  fitbit: 'From Fitbit',
  garmin: 'From Garmin',
}

export default function PrefillPill({ source = 'oura', className }: PrefillPillProps) {
  return (
    <span className={`prefill-pill ${className || ''}`} title="Auto-filled from your wearable — edit to override">
      {LABELS[source] || 'Auto-filled'}
    </span>
  )
}
